import React, { useCallback, useMemo } from 'react';
import { isNull, isUndefined } from 'lodash/fp';

import styles from './TableInstanceFilters.module.scss';
import { ToggleFilter } from './ToggleFilter';

interface CheckboxFilterProps {
    updateFilter: (value: boolean) => void;
    removeFilter: () => void;
    filter: boolean | null;
    testId: string;
}

export const CheckboxFilter: React.FC<CheckboxFilterProps> = ({ updateFilter, removeFilter, filter, testId }) => {
    const checkboxFilter = useMemo(() => isNull(filter) ? undefined : filter, [filter]);
    const updateCheckboxFilter = useCallback((value: boolean | undefined) => isUndefined(value) ? removeFilter() : updateFilter(value), [removeFilter, updateFilter]);
    return (
        <div className={styles.checkboxFilterWrapper}>
            <ToggleFilter filter={checkboxFilter} testId={testId} updateFilter={updateCheckboxFilter} />
        </div>
    );
};
